import { AccountLinksDto } from '../dto/users-account-links.dto'
import { AccountLinkModel, AccountRoleType, AccountSourceType, PermissionType } from '../models/users-account-links-model'
import { fromZonedTime } from '@e3dc-react/shell/Libs/date'

export const accountLinksDtoToModelTransformer = (response: AccountLinksDto | undefined): AccountLinkModel[] => {
  return response
    ? response.id.map((id, index) => ({
        id: Number(id),
        installationId: response.installationId[index] || -1,
        accountId: Number(response.accountId[index]) || -1,
        accountType: response.accountType[index] || -1,
        accountSource: (response.accountSource[index] as AccountSourceType) || 'e3dc',
        role: response.role[index] as AccountRoleType,
        inviteId: response.inviteId[index] || '',
        startAt: fromZonedTime(response.startAt[index], 'UTC').toISOString(),
        stopAt: response.stopAt[index] ? fromZonedTime(response.stopAt[index], 'UTC').toISOString() : null,
        permissionType: (response.permissionType[index] as PermissionType) || 'ro',
        storagePermissionType: (response.storagePermissionType[index] as PermissionType) || 'ro',
        userName: response.userName[index] || '',
        firstName: response.firstName[index] || '',
        lastName: response.lastName[index] || '',
        companyName: response.companyName ? response.companyName[index] : '',
        createdAt: fromZonedTime(response.createdAt[index], 'UTC').toISOString(),
        updatedAt: fromZonedTime(response.updatedAt[index], 'UTC').toISOString(),
        decommissionedAt: response.decommissionedAt[index] ? fromZonedTime(response.decommissionedAt[index], 'UTC').toISOString() : null,
        hasReadAccess: response.permissionType[index] === 'rw' || response.permissionType[index] === 'ro',
        hasWriteAccess: response.permissionType[index] === 'rw',
      }))
    : []
}
